import React, { createContext, useReducer, useContext, useMemo } from 'react';

const initialState = {
  currentId: '',
  history: [''],
  data: {
  },
};

// Tipos de acción
const actionTypes = {
  SET_ID: 'SET_ID',
  UPDATE_DATA: 'UPDATE_DATA',
};

const storeReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_ID:
      return {
        ...state,
        currentId: action.payload.id,
        history: [...state.history, action.payload.id],
      };
    case actionTypes.UPDATE_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          [state.currentId]: { ...state.data[state.currentId], ...action.payload },
        },
      };
    default:
      return state;
  }
};

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(storeReducer, initialState);

  const currentItem = useMemo(() => getData(state), [state]);

  return (
    <StoreContext.Provider value={{ state, dispatch, currentItem }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useConditionedNavigator = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore debe ser usado dentro de un StoreProvider');
  }
  return context;
};

export const setId = (dispatch, id) => {
  dispatch({
    type: actionTypes.SET_ID,
    payload: { id },
  });
};

export const updateData = (dispatch, newData) => {
  dispatch({
    type: actionTypes.UPDATE_DATA,
    payload: newData,
  });
};

export const getData = (state) => {
  return state.data[state.currentId];
}